"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var account_1 = tslib_1.__importDefault(require("./account"));
var address_1 = tslib_1.__importDefault(require("./address"));
var bank_1 = tslib_1.__importDefault(require("./bank"));
var company_1 = tslib_1.__importDefault(require("./company"));
var state_1 = tslib_1.__importDefault(require("./state"));
var ClientResource = /** @class */ (function (_super) {
    tslib_1.__extends(ClientResource, _super);
    function ClientResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClientResource.endpoint = '/clients';
    ClientResource.related = {
        address_billing: address_1.default,
        address_client_contact: address_1.default,
        address_contact: address_1.default,
        address_mailing: address_1.default,
        bank: bank_1.default,
        company: company_1.default,
        deposit_account: account_1.default,
        receivable_account: account_1.default,
        parent_client: ClientResource,
        petty_cash_account: account_1.default,
        petty_cash_custodian_account: account_1.default,
        petty_cash_p_card_account: account_1.default,
        work_state: state_1.default
    };
    return ClientResource;
}(base_1.default));
exports.default = ClientResource;
//# sourceMappingURL=client.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/client.js
// module id = rgH3
// module chunks = 0